/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';
import { gray2, gray3 } from '../Styles';
import { QuestionData } from '../data';
import { Link } from 'react-router-dom';
import Chip from '@mui/material/Chip';
import Stack from '@mui/material/Stack';

interface Props {
    data: QuestionData;
    showCategory: boolean;
    showLabels: boolean;
}
export const Question = ({ data, showCategory, showLabels }: Props) => (
    <div
        css={css`
            padding: 10px 0px;
        `}
    >
        <div
            css={css`
                padding: 10px 0px;
                font-size: 19px;
            `}
        >
            <Link
                css={css`
                    text-decoration: none;
                    color: ${gray2};
                `}
                to={`/questions/${data.questionId}`}
            >
                {data.title}
            </Link>
        </div>
        {showLabels && data.labels.trim().length > 0 && (
            <div
                css={css`
                    padding-bottom: 10px;
                    font-size: 15px;
                    color: ${gray2};
                `}
            >
                <Stack direction="row" spacing={1}>
                    {data.labels.split(',').map((label, idx) => {
                        return <Chip key={idx} label={label.trim()} />;
                    })}
                </Stack>
            </div>
        )}
        {showCategory && (
            <div
                css={css`
                    padding-bottom: 10px;
                    font-size: 15px;
                    color: ${gray2};
                `}
            >
                <Link
                    css={css`
                        text-decoration: none;
                        color: ${gray2};
                        font-size: 16px;
                        font-weight: 300;
                    `}
                    to={`/categories/${data.categoryId}`}
                >
                    [ {data.categoryName} ]
                </Link>
            </div>
        )}
        <div
            css={css`
                font-size: 12px;
                font-style: italic;
                color: ${gray3};
            `}
        >
            {`Updated on ${data.updated.toLocaleDateString()} ${data.updated.toLocaleTimeString()}`}
        </div>
    </div>
);
